const buildEnvs = require('../../../_envs.json');

const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
const urlEnv =
    process.env.GATSBY_SITE_URL ||
    (buildEnvs[activeEnv]
        ? buildEnvs[activeEnv].PREFIX_URL_ENV
        : 'www');

export const ulrs = {
    'RJ30': `https://${urlEnv}.quickenloans.com/home-loans/30-year-fixed`,
    '130': `https://${urlEnv}.quickenloans.com/home-loans/30-year-fixed`,
    '930': `https://${urlEnv}.quickenloans.com/home-loans/30-year-fixed`,
    '830V': `https://${urlEnv}.quickenloans.com/home-loans/30-year-fixed`,
    '330': `https://${urlEnv}.quickenloans.com/home-loans/15-year-fixed`,
    '915': `https://${urlEnv}.quickenloans.com/home-loans/15-year-fixed`,
    "815V": `https://${urlEnv}.quickenloans.com/home-loans/15-year-fixed`,
}


